/* eslint-disable react/no-unknown-property */
import styles from './MapTag.module.scss';
import { Icon } from '../../../Icon/Icon';
import { Button } from '../../../Button/Button';
import { ColorPalettes } from '../../LandingBlock/LandingBlock';

interface MapTagProps {
  direction: string;
  lat: number;
  lng: number;
  googleLink?: string;
  colorPalette?: ColorPalettes;
}

export const MapTag = ({
  direction,
  lat,
  lng,
  colorPalette = 'doctor-1',
  googleLink,
}: MapTagProps) => {
  const onCopy = () => {
    if (!direction || !navigator.clipboard) return;

    navigator.clipboard.writeText(direction);
  };

  const onGoogle = () => {
    if (!googleLink) return;

    window.open(googleLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={styles.root}>
      <span className={styles.pin}>
        <Icon type="location" alt="Location" />
      </span>
      <div className={styles.direction}>
        <span className={styles.label}>Doctor Jessica Flores</span>
        <p className={styles.text}>{direction}</p>
        <div className={styles.actions}>
          <Button
            className={styles.copy}
            text="Copy"
            btnStyle="tertiary"
            onClick={onCopy}
          />
          <Button
            className={styles.google}
            text="Open map"
            btnStyle="tertiary"
            onClick={onGoogle}
            isDisabled={!googleLink}
          />
        </div>
      </div>
    </div>
  );
};
